// @flow

import * as React from 'react';
import ObfuscatedLink from '@ta/common.obfuscated-link';
import styles from './JvAdWrapper.less';


type Props = {
  data: {
    image: string,
    url: string,
  },
};

const JvAdWrapper = ({ data }: Props) => {
  if(Object.keys(data).length > 0) {
    return (
      <ObfuscatedLink encodedUrl={data.url} target='_blank' className={styles.jvAdWrapper}>
        <img src={data.image} />
      </ObfuscatedLink>
    )
  }
  return null;
}

export default JvAdWrapper;
